import { h } from "omi";

import { IconProps } from "@/components";

export function GithubIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={width} height={height}>
      <g clip-path="url(#a)">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M12 0C5.3724 0 0 5.3808 0 12.0204c0 5.31 3.438 9.816 8.2068 11.4048.6.1104.8184-.2604.8184-.5796 0-.2844-.0096-1.0416-.0156-2.0436-3.3384.726-4.0428-1.6116-4.0428-1.6116-.5448-1.3896-1.332-1.7592-1.332-1.7592-1.0896-.744.0828-.7296.0828-.7296 1.2036.084 1.8372 1.2384 1.8372 1.2384 1.0704 1.836 2.8092 1.3056 3.492.9984.1104-.7764.42-1.3056.7632-1.6056-2.664-.3036-5.466-1.3356-5.466-5.9412 0-1.3116.468-2.3856 1.2348-3.2256-.1236-.3036-.5352-1.5264.1176-3.18 0 0 1.008-.324 3.3 1.2312A11.476706 11.476706 0 0 1 12 5.8128c1.02.0048 2.046.138 3.0048.4044 2.2908-1.5552 3.2964-1.2324 3.2964-1.2324.6552 1.6548.2424 2.8776.12 3.1812.768.84 1.2336 1.914 1.2336 3.2256 0 4.6176-2.8068 5.634-5.4792 5.9316.4308.3708.8136 1.104.8136 2.226 0 1.6056-.0144 2.9028-.0144 3.2964 0 .3216.216.696.8256.5784 2.3896-.8015 4.4668-2.3336 5.9382-4.3799 1.4713-2.0464 2.2624-4.5033 2.2614-7.0237C24 5.3808 18.6264 0 12 0Z"
          clip-rule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
